module.exports = __webpack_public_path__ + "static/img/1.f39b615.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/sp/1.png
// module id = 3OFy
// module chunks = 0